import { render, staticRenderFns } from "./DemoCard.vue?vue&type=template&id=2b92a5ec&scoped=true"
import script from "./DemoCard.vue?vue&type=script&lang=ts"
export * from "./DemoCard.vue?vue&type=script&lang=ts"
import style0 from "./DemoCard.vue?vue&type=style&index=0&id=2b92a5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92a5ec",
  null
  
)

export default component.exports